import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IRequestConsultaAdicaoCategoria } from './types';

// ACTIONS
import {
	consultaAdicaoCategoriaSuccess,
	consultaAdicaoCategoriaFailure,
} from './action';

function* consultaAdicaoCategoria(request: ReducerAction) {
	const { payload }: { payload: IRequestConsultaAdicaoCategoria } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`consulta/${CHANNEL}/consultaAdicaoCategoria`,
		payload,
	);

	if (response.status === 200) {
		yield put(consultaAdicaoCategoriaSuccess(response));
	} else if (response.error) {
		yield put(consultaAdicaoCategoriaFailure());
	}
}

export default all([
	takeLatest(Types.CONSULTA_ADICAO_CATEGORIA, consultaAdicaoCategoria),
]);
